export function computeCenterOnMapPermission(
  isToday: boolean,
  activeMapStyle: 'on' | 'label' | 'off',
) {
  if (activeMapStyle === 'off') return 'disabledNoMarker'
  if (!isToday) return 'disabled'

  return 'enabled'
}
